export const ANSWERS_STATUS = {
  0: 'pages.broadcast.asking.notAnswered',
  1: 'pages.broadcast.asking.answered',
  2: 'pages.broadcast.asking.answeredLive',
} as const;
